import { ALL } from '../constants/partnering-networks';
import collapsedLogger from './collapsed-logger';
import getFormattedSRCNetworks from './get-formatted-src-networks';
import isTrue from './is-true';

/* returns an array of filtered sdks from orchestartion
 * @param  {Array} srcInfoSdks -  DCP onboarded supported SRC networks
 * @param  {obj} srcNetworks - Merchant supported srcNetworks from BE response
 * @param  {Boolean} futEnabled - futEnabled flag
 * @return {Array} unloadedSdks - return an array unloaded Sdks
*/
const getFilteredSdks = (srcInfoSdks, srcNetworks, futEnabled = false) => {
  const srcNetworkString = srcNetworks && srcNetworks.value;
  collapsedLogger('getFilteredSdks => ', srcNetworks);
  if (
    isTrue(futEnabled) ||
    (!isTrue(futEnabled) && (srcNetworkString.toUpperCase() === ALL || srcNetworkString === ''))
  ) {
    return srcInfoSdks;
  }
  const formatedSRCNetworks = getFormattedSRCNetworks(srcNetworks);
  return srcInfoSdks.filter(sdkInfo => {
    return formatedSRCNetworks.includes(sdkInfo.cardBrand);
  });
};

export default getFilteredSdks;
